var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMarker',{attrs:{"position":_vm.location.position,"clickable":_vm.clickable,"options":{
		'location_id': _vm.location.location_id
	},"icon":_vm.markerIcon,"opacity":_vm.opacity},on:{"mouseover":function($event){return _vm.$emit('mouseover')},"mouseout":function($event){return _vm.$emit('mouseout')},"click":function($event){return _vm.$emit('click', { location: _vm.location })}}})}
var staticRenderFns = []

export { render, staticRenderFns }